import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavItem,
  NavLink,
  NavMenu,
  NavBtn,
  NavBtnLink,
  Imagen
} from "./NavbarElements";
import { useTranslation } from "react-i18next";

const Navbar = ({ toogle, currentLanguage, onChangeLanguage }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const { t, i18n } = useTranslation();
  

  const handleLanguageChange = () => {
    const newLanguage = currentLanguage === "es" ? "en" : "es";
    onChangeLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };


  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to="/" onClick={toggleHome}>
              {/* Jonatan Ochoa */}
              <Imagen src="/jonalogo.svg" alt="jona ochoa" />
            </NavLogo>

            <MobileIcon onClick={toogle}>
              <FaBars />
            </MobileIcon>

            {/* <MobileLenguage onClick={handleLanguageChange}>
                {currentLanguage === "es" ? t("EN") : t("ES")}
              </MobileLenguage>  */}

            <NavMenu>
              {/* <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/home"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar.home")}
                </NavLink>
              </NavItem> */}

              <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/sobre-mi"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar.about")}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/proyectos"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar.projects")}
                </NavLink>
              </NavItem>
              
              <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/tecnologias"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar.skills")}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/reparacion-de-PC"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Reparaciones de PC
                </NavLink>
              </NavItem>

              {/* <NavItem>
                <NavLink
                  onClick={toggleHome}
                  to="/blog"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Blog
                </NavLink>
              </NavItem> */}

            </NavMenu>

            <NavBtn>

              {/* <NavBtnLink onClick={handleLanguageChange}>
                {currentLanguage === "es" ? t("EN") : t("ES")}
              </NavBtnLink>  */}

              <NavBtnLink
                to="/signin"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                {t("button")}
              </NavBtnLink>
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
